import React from 'react';

export default () => (
	<footer className='footer'>
		<div className='footer-content'>
			©2025	New Wave Property Group
		</div>
	</footer>
);
